export default __webpack_public_path__ + "static/media/money-back@3x.0efc7f01.png";